import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgStudent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M20 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M20 18a6 6 0 0 1 6 6v6.17H14V24a6 6 0 0 1 6-6"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M17.017 12.533a3.02 3.02 0 1 0 6.006 0l.994-.106a4.02 4.02 0 1 1-7.994 0z"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m19.98 34-8.67-1.66-1.9-11.41 10.57 1.66zM28.64 32.34 19.98 34V22.59l10.56-1.66z"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m19.98 32.55-7.26-1.6L11.13 20l8.85 1.31zM27.23 30.95l-7.25 1.6V21.31L28.82 20z"
      clipRule="evenodd"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m11.13 20-1.72.93 1.9.3M28.82 20l1.72.93-1.89.3z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m7.646 21.42 8.246 1.377-.164.986-6.854-1.144.688 3.935-.985.172z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      d="M10 32a2 2 0 1 0 0-4 2 2 0 0 0 0 4M30 32a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgStudent);

export default ForwardRef;
